import { SchemaFormat } from '@sonar-software/sonar-core';
import { TableFilter } from '../TableModifier';

import {
	AccessLevelFilter,
	AccessObjectSourceFilter,
	AccessTypeFilter,
	ActiveFilter,
	ApplicationFilter,
	ComplianceCategoryFilter,
	DateFilter,
	FieldTypeFilter,
	FieldUsageFilter,
	FilterComponent,
	InverseToggleFilter,
	LookAheadSalesforceUser,
	ManagedPackage,
	ObjectFilter,
	OwnerFilter,
	PageLayoutFilter,
	PermissionSourceFilter,
	Populated,
	PopulationPercentageFilter,
	PrimaryFilter,
	ProfileFilter,
	ReferenceCountFilter,
	SalesforceUserFilter,
	SensitivityLevelFilter,
	StakeholderFilter,
	StatusFilter,
	TagsFilter,
	TextFilter,
	ToggleFilter
} from '../filters';

const formatFilterMap: Partial<Record<SchemaFormat, FilterComponent>> = {
	[ SchemaFormat.Apps ]: ApplicationFilter,
	[ SchemaFormat.BooleanToggle ]: ToggleFilter,
	[ SchemaFormat.BooleanToggleInverse ]: InverseToggleFilter,
	[ SchemaFormat.Checkmark ]: ActiveFilter,
	[ SchemaFormat.DateTime ]: DateFilter,
	[ SchemaFormat.Description ]: Populated,
	[ SchemaFormat.HelpText ]: Populated,
	[ SchemaFormat.LookAheadSalesforceUser ]: LookAheadSalesforceUser,
	[ SchemaFormat.ManagedPackage ]: ManagedPackage,
	[ SchemaFormat.Object ]: ObjectFilter,
	[ SchemaFormat.Owner ]: OwnerFilter,
	[ SchemaFormat.PageLayouts ]: PageLayoutFilter,
	[ SchemaFormat.PermissionSources ]: PermissionSourceFilter,
	[ SchemaFormat.PopulationPercentage ]: PopulationPercentageFilter,
	[ SchemaFormat.Primary ]: TextFilter,
	[ SchemaFormat.Profiles ]: ProfileFilter,
	[ SchemaFormat.ReferenceCount ]: ReferenceCountFilter,
	[ SchemaFormat.SalesforceUser ]: SalesforceUserFilter,
	[ SchemaFormat.Stakeholder ]: StakeholderFilter,
	[ SchemaFormat.Tags ]: TagsFilter,
	[ SchemaFormat.Text ]: TextFilter
};

const enumFilterMap: Record<string, FilterComponent> = {
	AccessLevel: AccessLevelFilter,
	AccessObjectSource: AccessObjectSourceFilter,
	AccessType: AccessTypeFilter,
	ComplianceCategory: ComplianceCategoryFilter,
	DataSensitivityLevelId: SensitivityLevelFilter,
	FieldUsageId: FieldUsageFilter,
	Status: StatusFilter,
	Type: FieldTypeFilter
};

export const getFilterComponent = (filter: TableFilter): FilterComponent | null => {
	if (filter.filterFormat === SchemaFormat.Enum) {
		return enumFilterMap[ filter.filterId ] ?? null;
	}

	if (filter.filterFormat === SchemaFormat.Primary && filter.filterMetadata) {
		return PrimaryFilter;
	}

	return formatFilterMap[ filter.filterFormat as SchemaFormat ] ?? null;
};
